// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2l9HC","title":"AfterFrontImage_title__3OcW8"};